import { cn } from '@/src/shared/lib/shadcn';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'animate-pulse rounded-md bg-(--sc-skeleton) motion-reduce:animate-none',
        className,
      )}
      {...props}
    />
  );
}

export { Skeleton };
